// Data for the 4 Startup & Compliance service sub-pages.
// Referenced by StartupCompliancePage (index) and dynamic sub-pages.

export const startupServices = [
  {
    slug: 'company-incorporation',
    title: 'Company Incorporation',
    tagline: 'Pvt Ltd · LLP · OPC · Partnership',
    short: 'Incorporate your business with MCA in as little as 10 working days — end-to-end.',
    price: 'From ₹4,999',
    hero: {
      headline: 'Company incorporation',
      accent: 'made effortless',
      description: 'Pvt Ltd, LLP, OPC, Partnership or Sole Proprietorship — we take care of MCA filings, name approval, DIN/DSC, SPICe+ form and PAN/TAN allotment. Zero visits, all-digital.',
    },
    inclusions: [
      'Name reservation via RUN / SPICe+',
      'Digital Signature Certificates (DSC) for 2 directors',
      'Director Identification Numbers (DIN)',
      'MoA & AoA drafting',
      'PAN, TAN, GST, Professional Tax registration',
      'ESIC & EPF registration if applicable',
      'Bank account opening assistance',
      'Compliance calendar for year 1',
    ],
    documents: [
      'PAN of all directors / partners',
      'Aadhaar of all directors / partners',
      'Passport-sized photographs',
      'Address proof (utility bill / bank statement, <2 months)',
      'Proof of registered office (rent agreement + NOC)',
    ],
  },
  {
    slug: 'income-tax-filing',
    title: 'Income Tax Filing',
    tagline: 'ITR · Advance Tax · Tax Audit',
    short: 'CA-certified filing for individuals, professionals and companies. Maximise refunds, avoid notices.',
    price: 'From ₹2,500',
    hero: {
      headline: 'Income tax filing,',
      accent: 'done right the first time',
      description: 'Salary + capital gains, freelance, business income, or company ITR — we file, verify, respond to intimation and manage advance tax. Backed by CAs.',
    },
    inclusions: [
      'ITR-1 / 2 / 3 / 4 / 5 / 6 filing',
      'Form 3CA-3CD / 3CB-3CD tax audit',
      'Advance tax computation & challan',
      'Capital gains reconciliation (equity, MF, property)',
      'Foreign asset & FEMA compliance',
      '143(1) / 143(2) / 148 notice response',
      'Rectification & refund follow-up',
    ],
    documents: [
      'PAN and Aadhaar',
      'Form 16 / 16A (if salaried)',
      'Bank statements for the FY',
      'Investment proofs (80C, 80D, HRA)',
      'Capital gains statements from brokers',
      'Business books / P&L (if applicable)',
    ],
  },
  {
    slug: 'msme-udyam',
    title: 'MSME / Udyam Registration',
    tagline: 'Udyam Certificate · Govt Schemes',
    short: 'Register under Udyam and unlock MSME loans, subsidies, priority lending and tax breaks.',
    price: 'From ₹999',
    hero: {
      headline: 'Get your Udyam',
      accent: 'MSME certificate',
      description: 'Register your business as Micro, Small or Medium Enterprise. Unlock preferential government schemes, collateral-free loans and 45-day payment protection under MSMED Act.',
    },
    inclusions: [
      'Udyam registration certificate',
      'MSME classification (Micro/Small/Medium)',
      'Advisory on eligible government schemes',
      'PMEGP / CGTMSE / Mudra loan documentation',
      'GeM (Government e-Marketplace) onboarding',
      'Zero-Defect Zero-Effect (ZED) certification pathway',
    ],
    documents: [
      'Aadhaar of proprietor / authorised signatory',
      'PAN of business',
      'GSTIN (if applicable)',
      'Bank details of business',
      'NIC code / business activity description',
    ],
  },
  {
    slug: 'legal-drafting',
    title: 'Legal Drafting',
    tagline: 'Contracts · Agreements · Notices',
    short: 'Lawyer-drafted contracts, MoUs, shareholder agreements, IP assignments and legal notices.',
    price: 'From ₹3,000',
    hero: {
      headline: 'Legal documents,',
      accent: 'drafted by lawyers',
      description: 'Watertight contracts drafted by practising lawyers. From founders\' agreements to employment contracts, NDAs, IP assignments and legal notices — enforceable and jurisdiction-specific.',
    },
    inclusions: [
      'Founders / Shareholders Agreement',
      'Employment / Consultancy contracts',
      'NDA, non-compete, non-solicitation',
      'MoU, service level agreements',
      'IP assignment & licensing',
      'Terms of Service & Privacy Policy',
      'Legal notices & replies',
      'Vendor & partnership agreements',
    ],
    documents: [
      'Details of parties involved',
      'PAN / Aadhaar / KYC of signatories',
      'Governing law preference',
      'Any prior agreements or drafts',
    ],
  },
];

export const getStartupService = (slug) => startupServices.find((s) => s.slug === slug);
